module.exports = __webpack_public_path__ + "static/media/systemUp.dd0ecb52.svg";